import { render, staticRenderFns } from "./mermaid.vue?vue&type=template&id=c0043b22&scoped=true"
import script from "./mermaid.vue?vue&type=script&lang=js"
export * from "./mermaid.vue?vue&type=script&lang=js"
import style0 from "./mermaid.vue?vue&type=style&index=0&id=c0043b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0043b22",
  null
  
)

export default component.exports